<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px"
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-form ref="form" @submit.prevent="saveClick">
      <v-card max-height="100%">  
        <v-card-title style="background-color: #004056" class="white--text">
          Properties you work on?
        </v-card-title>

        <v-divider />

        <!-- categories -->
        <v-card-text class="px-6 pt-4">
          <v-checkbox
            v-model="allowed"
            ref="trad"
            label="Residential Homes"
            color="primary"
            value="traditional"
            @click="$refs.form.validate()"
            :rules="[at_least_one]"
            class="mt-2" hide-details validate-on-blur
          />
          <v-checkbox
            v-model="allowed"
            ref="mh"
            label="Mobile Homes"
            color="primary"
            value="mobile_home"
            @click="$refs.form.validate()"
            :rules="[at_least_one]"
            class="mt-2" hide-details validate-on-blur
          />
          <v-checkbox
            v-model="allowed"
            ref="rv"
            label="RV's"
            color="primary"
            value="rv"
            @click="$refs.form.validate()"
            :rules="[at_least_one]"
            class="mt-2" hide-details="auto" validate-on-blur
          />
        </v-card-text>

        <v-divider />

        <!-- buttons -->
        <v-card-actions class="justify-center py-3">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn class="ml-3" color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <ErrorOverlay
      title="Property Type Error" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </v-dialog>
</template>

<script>
import { ActivatorButton, ErrorOverlay } from '@/components/pages';
import { mapActions } from 'vuex'

export default {
  name: 'YouPropertyTypesDialog',
  
  props: ['pro'],

  components: { ActivatorButton, ErrorOverlay },

  data: () => ({
    dialogVisible: false,
    allowed: [],

    // error handling
    loading: false,
    error_dialog: false,
    error_message: '',
  }),

  computed: {
    // validations
    at_least_one() {
      return () => this.allowed.length > 0 || 'At least one item should be selected'
    },
  },

  watch: {
    dialogVisible(visible) {
      this.$refs.form?.resetValidation()
      if (visible) {
        this.allowed = this.invert(this.pro.excluded_structure_types)
      }
    },
  },

  methods: {
    ...mapActions('auth', ['loadMe', 'updateExcludedStructureTypes']),

    close() {
      this.dialogVisible = false
    },

    invert(structures) {
      let res = [ 'mobile_home', 'rv', 'traditional' ]

      if (!structures) { return res }

      return res.filter(s => !structures.includes(s))
    },

    activeText(structureType)  {
      return this.allowed.includes(structureType) ? '-on-' : '-off-'
    },

    async saveClick() {
      if (this.$refs.form.validate()) {
        let excluded_structure_types = this.invert(this.allowed)

        let { pro_id } = this
        const result = await this.updateExcludedStructureTypes({ pro_id, excluded_structure_types })

        if (result.ok) {
          this.dialogVisible = false
          this.loadMe()
        } else {
          this.error_dialog = true
          this.error_message = result.error
        }
      }
    },
  },
}
</script>

<style scoped>
  .v-dialog__content {
    position: absolute;
  }
</style>